export const tools = [
  {
    path: '/tools',
    component: () => import(/* webpackChunkName: "tools" */ '@/views/tools/Tools'),
    children: [
      {
        path: 'participations',
        component: () => import(/* webpackChunkName: "tools" */ '@/views/tools/components/ToolsParticipations'),
      },
      {
        path: 'clearing',
        component: () => import(/* webpackChunkName: "tools" */ '@/views/tools/components/ToolsClearing'),
      },
      {
        path: 'import',
        component: () => import(/* webpackChunkName: "tools" */ '@/views/tools/components/ToolsImport'),
      },
    ],
    redirect: '/tools/participations',
  },
]
